/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkPackagePriorityRequest } from '../../models/update-work-package-priority-request';
import { WorkPackagePriorityDto } from '../../models/work-package-priority-dto';

export interface UpdateWorkPackagePriority$Params {
  id: string;
      body: UpdateWorkPackagePriorityRequest
}

export function updateWorkPackagePriority(http: HttpClient, rootUrl: string, params: UpdateWorkPackagePriority$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackagePriorityDto>> {
  const rb = new RequestBuilder(rootUrl, updateWorkPackagePriority.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackagePriorityDto>;
    })
  );
}

updateWorkPackagePriority.PATH = '/v0/workPackagePriorities/{id}';
